import React, { useRef, Fragment } from "react";
import TYPE from "../../../constant/TYPE";
import { getMathJaxNode } from "../mathjax/MathJax";
import IntervalTable from "./IntervalTable";
import NumberTable from "./NumberTable";
import CollectAndSplit from "./CollectAndSplit";
import MultiplicationAndDivision from "./MultiplicationAndDivision";
import FactorsAndMultiples from "./FactorsAndMultiples";
import SizeComparison from "./SizeComparison";
import PrimeFactorization from "./primeFactorization/PrimeFactorization";
import CyclicDecimal from "./cyclicDecimal/CyclicDecimal";
import Factorization from "./Factorization";
import DistributiveLaw from "./distributiveLaw/DistributiveLaw";

const grammarData = [
  { type : TYPE.LATEX_CODE.INTERVAL_TABLE, component : IntervalTable },
  { type : TYPE.LATEX_CODE.NUMBER_TABLE, component : NumberTable },
  { type : TYPE.LATEX_CODE.COLLECT_AND_SPLIT, component : CollectAndSplit },
  { type : TYPE.LATEX_CODE.MULTIPLICATION_AND_DIVISION, component : MultiplicationAndDivision },
  { type : TYPE.LATEX_CODE.FACTORS_AND_MULTIPLES, component : FactorsAndMultiples },
  { type : TYPE.LATEX_CODE.SIZE_COMPARISON, component : SizeComparison },
  { type : TYPE.LATEX_CODE.PRIME_FACTORIZATION, component : PrimeFactorization },
  { type : TYPE.LATEX_CODE.CYCLIC_DECIMAL, component : CyclicDecimal },
  { type : TYPE.LATEX_CODE.FACTORIZATION, component : Factorization },
  { type : TYPE.LATEX_CODE.DISTRIBUTIVE_LAW, component : DistributiveLaw }
];

const GrammarViewer = ( props ) => {

  const prevLatexCodes = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const latexCodes = props.children?.split( /\\br |\\br\r\n|\\br\r|\\br\n/ ) || [];
  const changedLatexCodesCount = latexCodes.filter( ( v, i ) => prevLatexCodes.current[ i ] !== v ).length;

  const mapViewers = ( value, index ) => {
    const grammar = grammarData.filter( v => value.indexOf( v.type ) > -1 )[ 0 ];
    const Viewer = grammar ? grammar.component : getMathJaxNode( props.type );
    return <div key={ index } className="pv-ib"><Viewer type={ props.type } onRender={ renderMathJax }>{ value }</Viewer></div>;
  };

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    
    if ( changedLatexCodesCount === mathjaxRenderCount.current ) {
      prevLatexCodes.current = latexCodes;
      mathjaxRenderCount.current = 0;
      props.onRender( props.name, Date.now() );
    }
  };

  const VIEWERS = latexCodes.map( mapViewers );

  return <Fragment>{ VIEWERS }</Fragment>;

};

GrammarViewer.defaultProps = {
  onRender : () => {}
};

export default GrammarViewer;
